export default function setAddEventDialogStateAction(state) {
   return {
      type : "SET_ADD_EVENT_DIALOG_STATE",
      payload: state,
   }
}



// WEBPACK FOOTER //
// ./src/actions/events/setAddEventDialogStateAction.js